var base = require('settings/teams/mailed-invitations');

Vue.component('spark-mailed-invitations', {
    mixins: [base],

    data: function(){
        return {
            headers: [{
                text: 'Email Address', value: 'email',  align: 'left'
            },{
                value: 'delete', sortable: false
            }]
        };
    }
});
